import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Dashboard.css"; // File CSS tùy chỉnh
import VehicleActivityRatesCollapse from "./VehicleActivityRatesCollapse";
import VehicleActivityRatesTable from "./VehicleActivityRatesTable";
import OverviewBox from "./OverviewBox";
import ProfitTable from "./ProfitTable";
import ProfitCollapse from "./ProfitCollapse";
import ManagerService from '../../services/ManagerService'; // Import ManagerService
import { isMobile } from "react-device-detect"; // Thư viện để phát hiện thiết bị

const DashboardComponent = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [currentData, setCurrentData] = useState(null);
  const [vehicleActivityRatesData, setVehicleActivityRatesData] = useState(null);
  const [profitData, setProfitData] = useState(null);
  const [viewMode, setViewMode] = useState("day");
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile); // Phát hiện thiết bị
    const fetchDashboardData = async () => {
      try {
        const response = await ManagerService.getDuLieuCoBan();
        setDashboardData(response);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    const fetchVehicleActivityRates = async () => {
      try {
        const response = await ManagerService.getTiLeHoatDong();
        setVehicleActivityRatesData(response);
      } catch (error) {
        console.error("Error fetching vehicle activity rates:", error);
      }
    };

    const fetchProfitData = async () => {
      try {
        const response = await ManagerService.getTiLeLoiNhuanTheoXe();
        setProfitData(response);
      } catch (error) {
        console.error("Error fetching profit data:", error);
      }
    };

    fetchDashboardData();
    fetchVehicleActivityRates();
    fetchProfitData();
  }, []);

  useEffect(() => {
    if (dashboardData && dashboardData.totalTrips && dashboardData.completedTrips) {
      setCurrentData({
        totalTrips: dashboardData.totalTrips[viewMode] || 0,
        completedTrips: dashboardData.completedTrips[viewMode] || 0,
        incompleteTrips: dashboardData.incompleteTrips[viewMode] || 0,
        totalRevenue: dashboardData.totalRevenue[viewMode] || 0,
        totalCustomers: dashboardData.totalCustomers[viewMode] || 0,
        totalTripsPrev: dashboardData.totalTrips[`${viewMode}Prev`] || 0,
        completedTripsPrev: dashboardData.completedTrips[`${viewMode}Prev`] || 0,
        incompleteTripsPrev: dashboardData.incompleteTrips[`${viewMode}Prev`] || 0,
        totalRevenuePrev: dashboardData.totalRevenue[`${viewMode}Prev`] || 0,
        totalCustomersPrev: dashboardData.totalCustomers[`${viewMode}Prev`] || 0,
      });
    }
  }, [dashboardData, viewMode]);

  const calculateGrowth = (current, previous) => {
    if (previous === 0) return null;
    return (((current - previous) / previous) * 100).toFixed(1);
  };

  if (!dashboardData || !vehicleActivityRatesData || !profitData) {
    return <div>Loading...</div>;
  }

  return (
    <Container fluid>
      <Row className="gy-3">
        {/* OverviewBox */}
        <Col xs={12} md={4} className="order-1 order-md-2">
          <OverviewBox
            viewMode={viewMode}
            setViewMode={setViewMode}
            currentData={currentData}
            calculateGrowth={calculateGrowth}
          />
        </Col>

        {/* VehicleActivityRates */}
        <Col xs={12} md={8} className="order-2 order-md-1">
          {isMobileDevice ? (
            <VehicleActivityRatesCollapse dashboardData={{ vehicleActivityRates: vehicleActivityRatesData }} />
          ) : (
            <VehicleActivityRatesTable dashboardData={{ vehicleActivityRates: vehicleActivityRatesData }} />
          )}
        </Col>

        {/* ProfitTable */}
        <Col xs={12} className="order-3">
        
        {isMobileDevice ? (
            <ProfitCollapse data={profitData} />
          ):(
            <ProfitTable data={profitData} />
            )}
          
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardComponent;
